import {ARIA_DRAWER_WIDTH_CSS_VAR} from '@wandb/forge-shell-contract';

// Display name shown to users across the agent chat UI.
export const AGENT_NAME = 'ARIA';

// Drawer dimensions
export const DEFAULT_DRAWER_WIDTH = 522;
export const MIN_DRAWER_WIDTH = 420;
export const MAX_DRAWER_WIDTH = 1569;
// Width available to page content beside the docked drawer. The drawer sets
// the CSS variable on <html> while mounted (see useMainContentInsetEffect).
export const MAIN_CONTENT_WIDTH_CSS = `calc(100vw - var(${ARIA_DRAWER_WIDTH_CSS_VAR}, 0px))`;
// Minimum width the main content area keeps beside the docked drawer. The
// drawer reserves layout space only down to this floor; any drawer width
// beyond it overlays the content instead.
export const MIN_MAIN_CONTENT_WIDTH = 900;

// Queued-message list
export const QUEUE_ROW_HEIGHT = 46; // 32px content + 12px padding + 2px border
export const QUEUE_MAX_HEIGHT = QUEUE_ROW_HEIGHT * 4 + 4 * 3; // 4 rows + 4px gaps
// MIN_THREAD_HEIGHT floors the thread viewport while a queue is present, so
// queued messages can't push the conversation out of view.
export const MIN_THREAD_HEIGHT = 160;
